export const getFirst = el => {
  if (!el) { return null }
  return Array.isArray(el) ? el[0] : el
}

export const getLast = el => {
  if (!el) { return null }
  return Array.isArray(el) ? el[el.length - 1] : el
}

export const exists = el => !!getFirst(el)
